// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5y2M8","top":"styles_top__2HfL8","left":"styles_left__oxDks","description":"styles_description__12SCa"};